export const modes = {
  normal: "NORMAL",
  presenter: "PRESENTER",
  overview: "OVERVIEW",
  grid: "GRID",
  print: "PRINT",
  master: "MASTER",
}
